import { Icon } from '@monash/portal-react';
import { isStringEmpty } from '@monash/portal-frontend-common';
import c from './icon-input.module.scss';
import React, { useRef, useState, useEffect, useMemo } from 'react';
import IconsMenu from './icons-menu/IconsMenu';
import IconDisplay from '../icon-display/IconDisplay';
import { computeAria } from './icons-menu/utils';

const IconInput = ({
  iconInput,
  setIconInput,
  currentUrl,
  urlInput,
  isShortcutActive,
  ...restProps
}) => {
  const iconButtonRef = useRef();
  const [iconMenuShown, setIconMenuShown] = useState(false);
  const iconAria = useMemo(() => {
    const ariaLabel = computeAria(iconInput);
    return ariaLabel
      ? `${ariaLabel} icon, change custom icon`
      : 'Add a custom icon';
  }, [iconInput]);

  // Remove favicon on url input changes
  useEffect(() => {
    if (iconInput?.type === 'favicon') {
      // remove favicon only when input is different from current shortcut or when its a newly added shortcut
      if (currentUrl !== urlInput || isStringEmpty(currentUrl)) {
        setIconInput(null);
      }
    }
  }, [urlInput]);

  // Close icon menu when shortcut is in drag and drop action
  useEffect(() => {
    if (isShortcutActive) {
      setIconMenuShown(false);
    }
  }, [isShortcutActive]);

  return (
    <div className={c.iconInput} data-status={iconInput}>
      <button
        className={c.button}
        onClick={() => setIconMenuShown(true)}
        type="button"
        aria-label={iconAria}
        ref={iconButtonRef}
        {...restProps}
      >
        {iconInput ? (
          <IconDisplay icon={iconInput} url={urlInput} />
        ) : (
          <Icon.Plus size={24} color="var(--card-text-secondary-color)" />
        )}
      </button>
      {iconMenuShown ? (
        <IconsMenu
          isShown={iconMenuShown}
          setIsShown={setIconMenuShown}
          triggerRef={iconButtonRef}
          urlInput={urlInput}
          iconInput={iconInput}
          setIconInput={setIconInput}
        />
      ) : null}
    </div>
  );
};

export default IconInput;
